import React, { useMemo } from "react";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";
import StatsGrid from "./components/StatsGrid";
import FormSubmissionsTable from "./components/FormSubmissionsTable";
import SettingsCard from "./components/SettingsCard";
import { downloadExcel, useHomepageData } from "./homePageData";

import "./index.scss";

const AdminHomePage = () => {
  const {
    sidebarOpen,
    setSidebarOpen,
    sidebarCollapsed,
    setSidebarCollapsed,
    activeTab,
    setActiveTab,
    handleLogout,
    tableData,
    loading,
    fetchError,
    debugInfo,
    minSubmittedDate,
    maxSubmittedDate,
    filters,
    search,
    setSearch,
    currentPage,
    visibleData,
    paginatedData,
    totalPages,
    handlePageChange,
    handleFilterChange,
    handleDownloadFiltered,
  } = useHomepageData();

  // Render dashboard content based on active tab
  const renderContent = useMemo(() => {
    switch (activeTab) {
      case "dashboard":
        return (
          <div className="dashboard-content">
            <h1 className="page-title">Dashboard Overview</h1>
            <StatsGrid
              totalCount={tableData.length}
              filteredCount={visibleData.length}
            />
          </div>
        );
      case "users":
        return (
          <div className="dashboard-content">
            <h1 className="page-title">Form Submissions</h1>
            <FormSubmissionsTable
              visibleData={visibleData}
              paginatedData={paginatedData}
              loading={loading}
              fetchError={fetchError}
              debugInfo={debugInfo}
              tableData={tableData}
              minSubmittedDate={minSubmittedDate}
              maxSubmittedDate={maxSubmittedDate}
              filters={filters}
              search={search}
              onSearchChange={(e) => setSearch(e.target.value)}
              onFilterChange={handleFilterChange}
              onDownloadFiltered={handleDownloadFiltered}
              onDownloadAll={() =>
                downloadExcel(tableData, "all_admin_dashboard_data.csv")
              }
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        );
      case "settings":
        return (
          <div className="dashboard-content">
            <h1 className="page-title">Settings</h1>
            <SettingsCard />
          </div>
        );
      default:
        return null;
    }
  }, [
    activeTab,
    tableData,
    visibleData,
    paginatedData,
    loading,
    fetchError,
    debugInfo,
    minSubmittedDate,
    maxSubmittedDate,
    filters,
    search,
    currentPage,
    totalPages,
    handleFilterChange,
    handleDownloadFiltered,
    handlePageChange,
    setSearch,
  ]);

  return (
    <div className="home-page-container">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onLogout={handleLogout}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed((prev) => !prev)}
      />

      <div className={`main-content ${sidebarCollapsed ? "collapsed" : ""}`}>
        <TopBar onMenuClick={() => setSidebarOpen(true)} />

        {renderContent}
      </div>
    </div>
  );
};

export default AdminHomePage;
